import { useState } from "react";
import usePokemonList from "../../hooks/usePokemonList";
import Card from "./Card";

function CardContainer() {
  const {
    pokemons,
    loading,
    error,
    nextPageUrl,
    prevPageUrl,
    gotoNextPage,
    gotoPrevPage,
  } = usePokemonList();

  const [selectedPokemon, setSelectedPokemon] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleModal = (pokemonName) => {
    setSelectedPokemon(pokemonName);
    setShowModal(true);
  };

  return (
    <Card
      pokemons={pokemons}
      loading={loading}
      error={error}
      nextPageUrl={nextPageUrl}
      prevPageUrl={prevPageUrl}
      pokemonName={selectedPokemon}
      showModal={showModal}
      setShowModal={setShowModal}
      gotoNextPage={gotoNextPage}
      gotoPrevPage={gotoPrevPage}
      handleModal={handleModal}
    />
  );
}

export default CardContainer;
